<script setup lang="ts">
// @ts-nocheck
import { RouterLink } from 'vue-router';

defineOptions({
  inheritAttrs: false
})

const props = defineProps({
  // @ts-ignore
  ...RouterLink.props,
  inactiveClass: String
})

const isExternalLink = computed(() => typeof props.to === 'string' && props.to.startsWith('http'))
</script>

<template>
  <a v-if="isExternalLink" v-bind="$attrs" :href="to" target="_blank">
    <slot />
  </a>

  <router-link
    v-else
    :to="$props.to"
    v-bind="$props"
    custom
    v-slot="{ isActive, href, navigate }"
    exact
  >
    <a
      v-bind="$attrs"
      :href="href"
      @click="navigate"
      :class="isActive ? activeClass : inactiveClass"
      class="text-indigo-800 font-bold flex items-center gap-1"
    >
      <slot />
    </a>
  </router-link>
</template>